import useScript from '@sls-react/hooks/useScript';
import getEnv from '@sls-react/utils/getEnv';
import { getErrorMessage } from '@sls-react/api/ApiError';
import waitUntil from '@sls-react/utils/waitUntil';

class RecaptchaExecutionFailure extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RecaptchaExecutionFailure';
  }
}

type RecaptchaActionType =
  | 'checkout'
  | 'guest_register'
  | 'login'
  | 'payment_method'
  | 'register'
  | 'bumps'
  | 'client_token'
  | 'social_auth';

export default function useRecaptcha() {
  const [scriptLoaded, scriptError] = useScript(
    `https://www.google.com/recaptcha/api.js?render=${getEnv(
      'RECAPTCHA_V3_KEY',
    )}`,
  );

  function getRecaptchaToken(action: RecaptchaActionType) {
    return new Promise<string>(async (resolve, reject) => {
      await waitUntil(() => window.grecaptcha != null);

      grecaptcha.ready(() => {
        grecaptcha
          .execute(getEnv('RECAPTCHA_V3_KEY')!, {
            action,
          })
          .then(
            token => {
              resolve(token);
            },
            err => {
              reject(new RecaptchaExecutionFailure(getErrorMessage(err)));
            },
          );
      });
    });
  }

  return {
    getRecaptchaToken,
    scriptLoaded,
  };
}
